/**
 * Password policy applied ONLY to new accounts (visitor + establishment register).
 * Existing users keep their current password — no forced reset.
 *
 * Rules:
 *   - min 8 characters
 *   - at least 1 digit
 *   - at least 1 letter
 *   - at least 1 special character (e.g. * . ! / @ # _ - + = ( ) [ ] { } ? , ; : " ' & |)
 */
const MIN_LEN = 8;
const DIGIT = /\d/;
const LETTER = /[a-zA-ZÀ-ÿ]/;
// eslint-disable-next-line no-useless-escape
const SPECIAL = /[^A-Za-zÀ-ÿ0-9]/;

export const PASSWORD_RULE_MESSAGE =
  "Votre mot de passe doit contenir au minimum 8 caractères, dont au moins 1 lettre, 1 chiffre et 1 caractère spécial.";

export function validatePassword(pwd) {
  if (!pwd || pwd.length < MIN_LEN) return { ok: false, reason: "length", message: PASSWORD_RULE_MESSAGE };
  if (!LETTER.test(pwd)) return { ok: false, reason: "letter", message: PASSWORD_RULE_MESSAGE };
  if (!DIGIT.test(pwd)) return { ok: false, reason: "digit", message: PASSWORD_RULE_MESSAGE };
  if (!SPECIAL.test(pwd)) return { ok: false, reason: "special", message: PASSWORD_RULE_MESSAGE };
  return { ok: true };
}

/** Small visual indicator helper — which of the 4 rules currently pass */
export function passwordCheckBreakdown(pwd) {
  return {
    length: (pwd || "").length >= MIN_LEN,
    letter: LETTER.test(pwd || ""),
    digit: DIGIT.test(pwd || ""),
    special: SPECIAL.test(pwd || ""),
  };
}
